/**
 * Anysa Product Page — 2-col desktop grid, mobile banner slider, lightbox, variant picker
 */
(function () {
  'use strict';

  /* ─────────────────────────────────────────
     Desktop grid images → lightbox on click
  ───────────────────────────────────────── */
  var gridImgs = Array.from(document.querySelectorAll('.an-pdp-grid-img'));
  var fullImages = gridImgs.map(function (el) {
    return el.dataset.full || el.style.backgroundImage.slice(5, -2);
  });

  var lightbox = document.getElementById('anLightbox');
  var lbImg = document.getElementById('anLightboxImg');
  var lbCounter = document.getElementById('anLightboxCounter');
  var lbClose = document.getElementById('anLightboxClose');
  var lbPrev = document.getElementById('anLightboxPrev');
  var lbNext = document.getElementById('anLightboxNext');
  var lbIdx = 0;

  function openLightbox(i) {
    if (!lightbox || !lbImg || !lbCounter || !fullImages.length) return;
    lbIdx = i;
    lbImg.src = fullImages[lbIdx];
    lbCounter.textContent = lbIdx + 1 + ' / ' + fullImages.length;
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }
  function lbNav(dir) {
    if (!lbImg || !lbCounter || !fullImages.length) return;
    lbIdx = (lbIdx + dir + fullImages.length) % fullImages.length;
    lbImg.src = fullImages[lbIdx];
    lbCounter.textContent = lbIdx + 1 + ' / ' + fullImages.length;
  }

  gridImgs.forEach(function (el, i) {
    el.addEventListener('click', function () {
      openLightbox(i);
    });
  });

  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbPrev)
    lbPrev.addEventListener('click', function () {
      lbNav(-1);
    });
  if (lbNext)
    lbNext.addEventListener('click', function () {
      lbNav(1);
    });
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('active')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lbNav(-1);
    if (e.key === 'ArrowRight') lbNav(1);
  });

  /* ─────────────────────────────────────────
     Mobile banner slider
  ───────────────────────────────────────── */
  var mobSlider = document.getElementById('anPdpMobSlider');
  var mobTrack = document.getElementById('anPdpMobTrack');
  var mobPrev = document.getElementById('anPdpMobPrev');
  var mobNext = document.getElementById('anPdpMobNext');
  var mobDotsWrap = document.getElementById('anPdpMobDots');
  var mobSlides = mobTrack ? Array.from(mobTrack.children) : [];
  var mobIdx = 0;
  var mobDots = [];

  function loadDeferredMobImage(index) {
    if (!mobSlides[index]) return;
    var deferredImg = mobSlides[index].querySelector(
      'img.an-pdp-mob-image-deferred',
    );
    if (!deferredImg || deferredImg.dataset.loaded === 'true') return;

    deferredImg.src = deferredImg.dataset.src || '';
    if (deferredImg.dataset.srcset)
      deferredImg.srcset = deferredImg.dataset.srcset;
    if (deferredImg.dataset.sizes)
      deferredImg.sizes = deferredImg.dataset.sizes;
    deferredImg.dataset.loaded = 'true';
  }

  if (mobTrack && mobSlides.length > 1) {
    loadDeferredMobImage(1);

    // Build dots
    if (mobDotsWrap) {
      mobSlides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'an-pdp-mob-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        dot.addEventListener('click', function () {
          mobGoTo(i);
        });
        mobDotsWrap.appendChild(dot);
        mobDots.push(dot);
      });
    }

    function mobGoTo(n) {
      mobIdx = (n + mobSlides.length) % mobSlides.length;
      loadDeferredMobImage(mobIdx);
      loadDeferredMobImage((mobIdx + 1) % mobSlides.length);
      mobTrack.style.transform = 'translateX(-' + mobIdx * 100 + '%)';
      mobDots.forEach(function (d, i) {
        d.classList.toggle('active', i === mobIdx);
      });
    }

    if (mobPrev)
      mobPrev.addEventListener('click', function () {
        mobGoTo(mobIdx - 1);
      });
    if (mobNext)
      mobNext.addEventListener('click', function () {
        mobGoTo(mobIdx + 1);
      });

    // Touch swipe
    var touchStartX = 0;
    if (mobSlider) {
      mobSlider.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].clientX;
        },
        { passive: true },
      );
      mobSlider.addEventListener(
        'touchend',
        function (e) {
          var diff = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(diff) > 40) mobGoTo(diff > 0 ? mobIdx - 1 : mobIdx + 1);
        },
        { passive: true },
      );
    }
  }

  /* ─────────────────────────────────────────
     Variant picker
  ───────────────────────────────────────── */
  var variants = window.anProductJSON || [];
  var selectedOptions = {};

  if (variants.length) {
    var first =
      variants.find(function (v) {
        return v.available;
      }) || variants[0];
    if (first.option1) selectedOptions[0] = first.option1;
    if (first.option2) selectedOptions[1] = first.option2;
    if (first.option3) selectedOptions[2] = first.option3;
  }

  function findVariant() {
    return variants.find(function (v) {
      if (selectedOptions[0] && v.option1 !== selectedOptions[0]) return false;
      if (selectedOptions[1] && v.option2 !== selectedOptions[1]) return false;
      if (selectedOptions[2] && v.option3 !== selectedOptions[2]) return false;
      return true;
    });
  }

  function updateVariant() {
    var variant = findVariant();
    if (!variant) return;
    var idInput = document.getElementById('anVariantId');
    var priceEl = document.getElementById('anPdpPrice');
    var compareEl = document.getElementById('anPdpComparePrice');
    var addBtn = document.querySelector('.an-pdp-add-cart');

    if (idInput) idInput.value = variant.id;
    if (priceEl) {
      priceEl.textContent = Shopify.formatMoney
        ? Shopify.formatMoney(variant.price)
        : '₹' + (variant.price / 100).toLocaleString('en-IN');
    }
    if (compareEl) {
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        compareEl.textContent = Shopify.formatMoney
          ? Shopify.formatMoney(variant.compare_at_price)
          : '₹' + (variant.compare_at_price / 100).toLocaleString('en-IN');
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.innerHTML =
          'Add to Cart <svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
      } else {
        addBtn.disabled = true;
        addBtn.innerHTML =
          'Sold Out <svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
      }
    }
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  document.querySelectorAll('.an-pdp-size').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn
        .closest('.an-pdp-option-group')
        .querySelectorAll('.an-pdp-size')
        .forEach(function (b) {
          b.classList.remove('active');
        });
      btn.classList.add('active');
      selectedOptions[parseInt(btn.dataset.optionIndex, 10)] =
        btn.dataset.value;
      updateVariant();
    });
  });

  document.querySelectorAll('.an-pdp-color').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn
        .closest('.an-pdp-option-group')
        .querySelectorAll('.an-pdp-color')
        .forEach(function (b) {
          b.classList.remove('active');
        });
      btn.classList.add('active');
      selectedOptions[parseInt(btn.dataset.optionIndex, 10)] =
        btn.dataset.value;
      updateVariant();
    });
  });
})();
